import {inject, Injectable} from '@angular/core';
import {MarketingBlocksApiService} from "../services-api/marketing-blocks-api.service";

@Injectable({
  providedIn: 'root'
})
export class MarketingBlocksService {
  private marketingBlocksApiService: MarketingBlocksApiService = inject(MarketingBlocksApiService);

  public initializeMarketingBlocks(productCardId: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.marketingBlocksApiService.initializeMarketingBlocks(productCardId).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }
}
